import styled, { css } from 'styled-components'
import { PlusIcon } from '@sainsburys-tech/bolt-icons'
import { Column } from '@sainsburys-tech/bolt'

const pointSize = 40
const pointOffset = 20

const pointHoverSize = 28
const pointHoverOffset = pointOffset - (pointSize - pointHoverSize) / 2

const getPointPosition = (pos, offset = pointOffset) => `calc(${pos * 100}% - ${offset}px)`

const pointCss = (x, y, size, offset) => css`
  width: ${size}px;
  height: ${size}px;
  left: ${getPointPosition(x, offset)};
  top: ${getPointPosition(y, offset)};
`

const Wrapper = styled(Column)`
  position: relative;
  width: 100%;
  img {
    object-fit: cover;
    ${(props) =>
      props.isEditorial &&
      css`
        height: 100%;
      `}
  }
`

const Point = styled.div`
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  opacity: 0.99;
  justify-content: center;
  position: absolute;
  transition: 0.2s linear;
  z-index: 2;

  ${(props) =>
    css`
      ${pointCss(props.points.x, props.points.y, pointSize, pointOffset)}
      background: ${props.theme.color.monochrome.white};

      &:hover,
      &:active,
      &:focus {
        ${pointCss(props.points.x, props.points.y, pointHoverSize, pointHoverOffset)}
      }

      &:hover,
      &:focus {
        box-shadow: 0 0 0 12px ${`${props.theme.color.monochrome.black}4D`};
      }
    `}
  ${(props) =>
    props.isActive &&
    css`
      transform: rotate(45deg);
      box-shadow: 0 0 0 8px ${`${props.theme.color.monochrome.black}4D`};
    `}
`

const Icon = styled(PlusIcon)`
  float: left;
  fill: ${(props) => props.theme.color.monochrome.base};
  width: ${(props) => props.theme.size.spacing.xl};
  height: ${(props) => props.theme.size.spacing.xl};
`
const ProductsWrapper = styled(Column)`
  padding-left: 0;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.isEditorial ? 'flex-start' : 'space-between')};
  ${(props) =>
    props.isEditorial &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        min-height: ${props.containsImage ? '550px' : '450px'};
      }
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        min-height: ${props.containsImage ? '580px' : '480px'};
      }
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
        min-height: ${props.containsImage ? '630px' : '530px'};
      }
    `}
  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        padding-left: ${props.theme.size.spacing.lg};
    `}
  ${(props) =>
    props.isEditorial &&
    css`
  @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
    padding-left: 0;
  `}
`
export { Wrapper, Point, Icon, ProductsWrapper }
